import { defineStore } from 'pinia';

export default defineStore('appStore', {
  state: () => ({
    modele: null,
    messageSoutien: null,
    texteDynamique: null,
    nomRegion: null,
    erreur: null,

    estMobile: false,
  }),
  getters: {},
  actions: {},
});
